import styles from "./index.module.css";
import React from "react";
import PinIcon from "shared/PinIcon";
import PropTypes from "prop-types";

/**
 * Displays a Diamond icon and label depending on the pinLevel ( 1-4 (diamond, emerald, platinum and associate) )
 */

export default function PinLabel({ pinLevel }) {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <PinIcon pinLevel={pinLevel} />
      </div>
      <span className={styles.label}>{pinNames[pinLevel] || "???"}</span>
    </div>
  );
}

const pinNames = {
  4: "Diamond",
  3: "Emerald",
  2: "Platinum",
  1: "Associate IBO",
};

PinIcon.propTypes = {
  /**
   * Determines the style of the diamond (pinIcon) and the name of the label ( 1-4 (diamond, emerald, platinum and associate) )
   */
  pinLevel: PropTypes.number,
};
